
export default {
    //IBKR lite user: CLNTPORTAL-1549
    allowFeatures: {},
    // provides currently iserver's selected account. undefined represents account switch is in progress
    selectedAccount: '',
    upnl: {},
    iserverInfo: {},
    status: {
        authenticated: undefined,
        competing: undefined,
        connected: undefined,
        message: '', // competing message
        fail: '', // used by order entry; some bond messages come over this fail
        prompts: [] // used for unsolicited messages, e.g mifid
    },
    notifications: [],
    //store order notifications if we receive any from backend, will get cleared when there is none.
    orders: [],
    trades: undefined,
    bulletins: [],
    readBulletins: [], // array of read bulletin IDs
    marketData: {},
    /* Used mainly by quicktrade; in global state for convenience.
     * Some users in development are only known to brokerage and not ibcust; for those users we use
     * the list of iserver accounts for the portfolio view. */
    accounts: [],
    groups: [],
    profiles: [],
    acctProps: {}, // holds list of allowed features / properties per account.
    chartPeriods: {},
    aliases: {},
    // don't compete against other sessions; WebTrader, TWS.
    compete: false,
    links: {}, //CLNTPORTAL-1549, we can use this to store all links from iserver
    ssoDH: {}, // SSO DH info
    briefingArticle: {},
    currencyPairs: {}, //holds a list currencies and their valid currency pairs
    contractInfo: {}, // holds contract info where key is conid and value is conid's contract info
    ccyChartPair: undefined, //used in FullPage CCY to show the chart
    watchlistMap: {}, // a map of watchlistid with respective conids in it
    loggingIn: false, // true if iserver login is currently in progress
    availableAlerts: [],
    priceAlertsData: [],
    priceAlertsEmail: undefined,
    priceAlertsSwitch: true, // flag to show if priceAlerts email is active
    loadedPriceAlertsData: undefined,
    mtaAlerts: {},
    userTimeZone: undefined,
    loginInfo: {}, // contains data provided by iserver upon login
    exploreWls: [],
    watchlists: [],
    regSnapshots: {}, // contains previously requested regSnapshots keyed by conid
    loginStartTime: undefined // provides epoch time when iserver login process was started
}
